export enum permissions {
  viewPage = 'viewPage'
}
